"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blackbox = exports.DEFAULT_PREFS = exports.Prefs = exports.Catalogue = exports.State = exports.LatestTelemetryUpdate = exports.Telemetry = exports.SensorIdentifier = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../../date");
const cellular_1 = require("../../../../network/cellular");
const schema_1 = require("../../../../schema");
const capability_1 = require("../../capability");
const vendor_1 = require("../../vendor");
const _util_1 = require("../_util");
const Base = __importStar(require("../base"));
const failure_mode_1 = require("./failure-mode");
exports.NAMESPACE = 'Culligan.Device.Class.Blackbox';
const operatingModes = [
    'Standard',
    'Disabled',
    'Factory',
    'Fault',
    'Ota',
    'Startup',
    'Installation',
];
const powerProfiles = ['Standard', 'Eco', 'Sleep'];
const logLevels = ['Silent'];
const connectivity = ['Cellular', 'Wi-Fi', 'Ethernet'];
const Connectivity = Base.makeConnectivity(exports.NAMESPACE, connectivity);
const slots = [];
const sensors = {
    in_tds: capability_1.Telemetry.Sensor.Number({
        name: 'Inlet TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 1, max: 3000 }),
    }),
    out_tds: capability_1.Telemetry.Sensor.Number({
        name: 'Post-RO TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 1, max: 3000 }),
    }),
    wp: capability_1.Telemetry.Sensor.Number({
        name: 'Water Pressure',
        type: capability_1.Telemetry.WaterPressure,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Maximum({ max: 300 }),
    }),
    ct_mat: capability_1.Telemetry.Sensor.Number({
        name: 'Cold-Tank Water temperature (MAX)',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ct_mit: capability_1.Telemetry.Sensor.Number({
        name: 'Cold-Tank Water temperature (MIN)',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    ct_wt: capability_1.Telemetry.Sensor.Number({
        name: 'Cold Tank Water Temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 1, max: 15 }),
    }),
    ht_wt: capability_1.Telemetry.Sensor.Number({
        name: 'Hot Tank Water Temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 55, max: 92 }),
    }),
    lk_gnd: capability_1.Telemetry.Sensor.Boolean({
        name: 'Ground Leak Sensor',
        type: capability_1.Telemetry.LeakDetected,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    lk_bb: capability_1.Telemetry.Sensor.Boolean({
        name: 'Blackbox Leak Sensor Active',
        type: capability_1.Telemetry.LeakDetected,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    ov_wd_fb_d: capability_1.Telemetry.Sensor.Number({
        name: 'Overall Water dispensed (24H)',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 999 }),
    }),
};
exports.SensorIdentifier = effect_1.Schema.Literal(...effect_1.Record.keys(sensors)).annotations({
    identifier: `${exports.NAMESPACE}.SensorIdentifier`,
});
const alarmingSensors = ['ht_wt'];
const alarms = {
    consumableBased: [],
    firmwareBased: [],
    telemetryBased: [capability_1.Alarm.OutOfRange, capability_1.Alarm.LeakBB, capability_1.Alarm.LeakBottom],
};
const events = [capability_1.Event.DailyPowerConsumed, capability_1.Event.DailyWaterDispensed];
exports.Telemetry = effect_1.Schema.Struct({
    in_tds: capability_1.Telemetry.WaterTDS.FromScalar,
    out_tds: capability_1.Telemetry.WaterTDS.FromScalar,
    wp: capability_1.Telemetry.WaterPressure.FromScalar,
    ct_mat: capability_1.Telemetry.WaterTemperature.FromScalar,
    ct_mit: capability_1.Telemetry.WaterTemperature.FromScalar,
    ct_wt: capability_1.Telemetry.WaterTemperature.FromScalar,
    ht_wt: capability_1.Telemetry.WaterTemperature.FromScalar,
    lk_gnd: capability_1.Telemetry.LeakDetected.FromScalar,
    lk_bb: capability_1.Telemetry.LeakDetected.FromScalar,
    ov_wd_fb_d: capability_1.Telemetry.WaterDispensed.FromScalar,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
exports.LatestTelemetryUpdate = effect_1.Schema.Record({
    key: exports.SensorIdentifier,
    value: effect_1.Schema.DateFromNumber,
})
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${exports.NAMESPACE}.LatestTelemetryUpdate`,
});
exports.State = effect_1.Schema.Struct({
    ...Base.State.fields,
    operatingMode: effect_1.Schema.Literal(...operatingModes),
    powerProfile: effect_1.Schema.Literal(...powerProfiles),
    logLevel: effect_1.Schema.Literal(...logLevels),
    connectivity: effect_1.Schema.optionalWith(Connectivity, { exact: true }),
    cpsi: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    iccid: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(cellular_1.Iccid), { exact: true }),
    imei: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    timezone: effect_1.Schema.optionalWith(date_1.TimezoneOffset, { exact: true }),
    location: effect_1.Schema.optionalWith(Base.NullableDetectedLocation, { exact: true }),
    batch: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    sku: effect_1.Schema.optionalWith(effect_1.Schema.Null, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.Catalogue = (0, _util_1.makeCatalogue)(slots).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
});
exports.Prefs = effect_1.Schema.Struct({}).annotations({ identifier: `${exports.NAMESPACE}.Prefs` });
exports.DEFAULT_PREFS = {};
const PrefsFromPartial = (0, schema_1.StructFromPartial)({})(exports.Prefs);
const identifier = `${exports.NAMESPACE}.Blackbox`;
/**
 * @author Federico Lotta - Lead Engineer <federico.lotta@culligan.com>
 * @author Troy Nuttall - Product Owner <troy@culliganquench.com>
 */
class Blackbox extends effect_1.Schema.Class(identifier)({
    model: effect_1.Schema.tag('bbfc'),
    alarms: (0, _util_1.makeActiveAlarms)(alarms),
    consumables: (0, _util_1.makeSlottedConsumables)(slots),
    state: exports.State,
    latestTelemetry: effect_1.Schema.partialWith(exports.Telemetry, { exact: true }),
    latestTelemetryUpdate: effect_1.Schema.optionalWith(exports.LatestTelemetryUpdate, {
        exact: true,
        default: () => ({}),
    }),
    prefs: effect_1.Schema.optionalWith(exports.Prefs, { exact: true, default: () => ({}) }),
    vendor: vendor_1.Quench.DeviceInfo,
    ...Base.CommonProps.fields,
}, { identifier }) {
    static code = 'bbfc';
    static label = 'Blackbox Bottle-Free Cooler';
    static category = 'Dispenser';
    static operatingModes = operatingModes;
    static powerProfiles = powerProfiles;
    static logLevels = logLevels;
    static slots = slots;
    static alarms = alarms;
    static sensors = sensors;
    static events = events;
    static connectivity = connectivity;
    static connectionGateway = 'TartabitBridge';
    static image = 'https://cdn.asp.events/CLIENT_Media_10_B9D470DF_5056_B739_5443B4BBAA6F8ED4/sites/CDW-2024/media/libraries/exhibitor-products/61139-HydroMe-image.png/fit-in/700x9999/filters:no_upscale()';
    static State = exports.State;
    static Prefs = exports.Prefs;
    static PrefsFromPartial = PrefsFromPartial;
    static Telemetry = exports.Telemetry;
    static Catalogue = exports.Catalogue;
    static vendors = [vendor_1.Quench.code];
    static init = (props, dates) => {
        return new this(Base.deviceInitProps({
            operatingMode: 'Standard',
            powerProfile: 'Standard',
            logLevel: 'Silent',
            connectivity: 'Cellular',
        }, slots, null, props, dates));
    };
    get code() {
        return `${this.vendor.code}${this.model}`;
    }
    get consumableAlarms() {
        return [];
    }
    get telemetryAlarms() {
        const sensorBasedAlarms = [];
        const outOfRangeAlarms = effect_1.Array.flatMapNullable(alarmingSensors, sensorId => {
            const measurement = this.latestTelemetry[sensorId];
            if (!measurement)
                return;
            if (capability_1.Telemetry.meetsExpectation(sensors[sensorId], measurement))
                return;
            return new capability_1.Alarm.OutOfRange({
                params: { telemetryId: sensorId, value: measurement.value },
            });
        });
        if (this.latestTelemetry.lk_bb?.value) {
            sensorBasedAlarms.push(new capability_1.Alarm.LeakBB());
        }
        if (this.latestTelemetry.lk_gnd?.value) {
            sensorBasedAlarms.push(new capability_1.Alarm.LeakBottom());
        }
        return [...outOfRangeAlarms, ...sensorBasedAlarms];
    }
    get manufacturingInfo() {
        return effect_1.Option.none();
    }
    get failureModes() {
        return (0, failure_mode_1.getFailureModes)(this);
    }
}
exports.Blackbox = Blackbox;
//# sourceMappingURL=index.js.map